import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DesabonnementService} from "../../core/services/desabonnement.service";
import {first} from "rxjs";

@Component({
  selector: 'app-desabonnement',
  templateUrl: './desabonnement.component.html',
  styleUrls: ['./desabonnement.component.scss']
})
export class DesabonnementComponent {
  email: any;
  sujet: any;
  reponse: any=false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private desabonnementService: DesabonnementService
  ) {
    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
      this.sujet = params['sujet'];
    });
  }
  desabonnement() {
    this.desabonnementService.getDesabonnement(this.email, this.sujet).pipe(first()).subscribe(response => {
      this.reponse=true;
    });
  }
  goAccueil(){
    void this.router.navigate([`/`]);
  }
}
